import { Controller } from "@hotwired/stimulus"

// USPS address-verification page: pick "Address Entered" vs "Suggested Address",
// update the sticky CTA preview, and route the CTA button to the selected
// option's hidden Rails link (preserves GET / PUT + CSRF behavior).
export default class extends Controller {
  static targets = ["row", "radio", "circle", "ctaName", "ctaAddr", "actEntered", "actSuggested"]

  select(event) {
    const row = event.currentTarget
    const index = this.rowTargets.indexOf(row)
    if (index === -1) return

    this.rowTargets.forEach((r, i) => {
      const on = i === index
      this.radioTargets[i].checked = on
      r.classList.toggle("sa-row--selected", on)
      this.circleTargets[i].classList.toggle("sa-radio--selected", on)
    })

    const { addrName, addrLine } = row.dataset
    if (this.hasCtaNameTarget) this.ctaNameTarget.textContent = addrName
    if (this.hasCtaAddrTarget) this.ctaAddrTarget.textContent = addrLine
  }

  use() {
    const checked = this.radioTargets.find(r => r.checked)
    const choice = checked ? checked.value : "entered"
    if (choice === "suggested" && this.hasActSuggestedTarget) {
      this.actSuggestedTarget.click()
    } else if (this.hasActEnteredTarget) {
      this.actEnteredTarget.click()
    }
  }
}
